import React, { createContext } from 'react';

const AuthenticationContext = createContext({
  instance: null,
  account: () => {},
  isAuthenticated: () => {},
  login: () => {},
  logout: () => {},
  renewToken: () => {},
  callWithToken: () => {},
  hasRole: () => {},
  addPreLoginHandler: () => {}
});

export default AuthenticationContext;
